import { render, staticRenderFns } from "./CadastroImunoPainel.vue?vue&type=template&id=f9435fd2&"
import script from "./CadastroImunoPainel.vue?vue&type=script&lang=js&"
export * from "./CadastroImunoPainel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports